import { Component, Input, OnInit } from '@angular/core';
import { Condolence } from 'src/app/models/Condolence';
import { Feed } from 'src/app/models/Feed';
import { FeedService } from 'src/app/services/modelService/feed.service';

@Component({
  selector: 'app-condolence',
  templateUrl: './condolence.component.html',
  styleUrls: ['./condolence.component.scss'],
})
export class CondolenceComponent implements OnInit {
  @Input() details = false;
  
  @Input() feed: Feed = new Condolence();
  constructor(public feedService:FeedService) { }

  ngOnInit() { }

}
